export const LOGIN_FAILURE_WINDOW_MS = 60 * 60 * 1000;

/**
 * A ladder maps a failure count to a lock duration: the highest threshold at
 * or below the actual count wins, so counts past the last entry keep its
 * duration as an explicit ceiling. The email ladder is tighter than the IP
 * ladder, since one IP legitimately represents many real logins.
 */
export type BackoffLadder = ReadonlyArray<readonly [threshold: number, lockMs: number]>;

export const EMAIL_BACKOFF_LADDER: BackoffLadder = [
  [5, 60 * 1000],
  [6, 5 * 60 * 1000],
  [7, 15 * 60 * 1000],
  [8, 60 * 60 * 1000],
];

export const IP_BACKOFF_LADDER: BackoffLadder = [
  [20, 60 * 1000],
  [25, 5 * 60 * 1000],
  [30, 15 * 60 * 1000],
  [40, 60 * 60 * 1000],
];

function backoffFromLadder(ladder: BackoffLadder, failures: number): number {
  let ms = 0;
  for (const [threshold, lockMs] of ladder) {
    if (failures >= threshold) ms = lockMs;
  }
  return ms;
}

export function loginBackoffMs(failures: number) {
  if (!Number.isInteger(failures) || failures < 1) return 0;
  return backoffFromLadder(EMAIL_BACKOFF_LADDER, failures);
}

export function ipLoginBackoffMs(failures: number) {
  if (!Number.isInteger(failures) || failures < 1) return 0;
  return backoffFromLadder(IP_BACKOFF_LADDER, failures);
}

export function loginRetryAfterSeconds(lockedUntil: Date | null, now = new Date()) {
  if (!lockedUntil || lockedUntil <= now) return 0;
  return Math.ceil((lockedUntil.getTime() - now.getTime()) / 1000);
}
